import { LucideIcon } from "lucide-react-native";

export interface Action {
  color: string;
  disabled?: boolean;
  divider?: true;
  icon: LucideIcon;
  label: string;
  onPress: () => void;
}
